module.exports = __webpack_public_path__ + "static/media/Viatorum_Map.2f8b0114.jpg";